import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ResponseData } from "../common"

export type SearchPropertyByIdType = {
  propertyId: string
  propertyName: string
}

export interface GetSearchPropertyByIdResponseData extends ResponseData {
  data: SearchPropertyByIdType
}
export interface GetSearchPropertyByIdResponse extends AxiosResponse {
  data: GetSearchPropertyByIdResponseData
}

export interface SearchPropertyByIdParams {
  propertyId: string
}

export interface SearchPropertyByIdRequest extends Partial<AxiosRequestConfig> {
  params: SearchPropertyByIdParams
}

export function getSearchPropertyByIdAPI(
  { params }: SearchPropertyByIdRequest,
  axiosInstance: AxiosInstance,
): Promise<GetSearchPropertyByIdResponse> {
  return axiosInstance({
    method: "get",
    url: `/property/search-property?propertyId=${params?.propertyId}`,
  }) as Promise<GetSearchPropertyByIdResponse>
}
